module.exports = __webpack_public_path__ + "givebutter-wordmark-e0bd262465f6d8b110c148669fe18f31.webp";